import React from 'react'
import CommonLayout from '../../../layouts/Common'
import { Container } from './style'
import MyIntegratedHealth from './MyIntegratedHealth'
import CommonMobileLayout from '../../../layouts/Common/Mobile'

const Questionnaires = () => {

  const renderQuestionnaire = () => {
    // switch (questionnaireResponse?.type) {
    //   case 'SocialSupportQuestionnaireResponse':
    //     return <SocialSupportQuestionnaireResponse questionnaireResponse={questionnaireResponse} />
    //   case 'BeqCcgResponse':
    //     return <ExpressivityResultResponse questionnaireResponse={questionnaireResponse} />
    //   case 'ErqCcgResponse':
    //     return <EmotionRegulationQuestionnaireResponse questionnaireResponse={questionnaireResponse} />
    //   case 'ConditionsOfMotherDuringPregnancyResponse':
    //     return <ConditionsDuringPregnancyOfYourMotherQuestionnaireResponse questionnaireResponse={questionnaireResponse} />
    //   case 'BisBasScaleResponse':
    //     return <BehavioralAvoidanceInhibitionQuestionnaireResponse questionnaireResponse={questionnaireResponse} />
    //   case 'MentalEmotionalFunctioningResponse':
    //     return <MentalEmotionalFunctioningQuestionnaireResponse questionnaireResponse={questionnaireResponse} />;
    //   case 'StressIndicatorsResponse':
    //     return <StressIndicatorsQuestionnaireResponse questionnaireResponse={questionnaireResponse} />;
    //   case 'NeurotransmittersResponse':
    //     return <NeurotransmittersQuestionnaireResponse questionnaireResponse={questionnaireResponse} />;
    //   case 'FoodIntakeAndDigestionResponse':
    //     return <FoodIntakeAndDigestionQuestionnaireResponse questionnaireResponse={questionnaireResponse} />;
    //   default:
    // }
    return <MyIntegratedHealth />
  };
  return (
    <>
      <CommonLayout title="" width="90%">
        <Container>
          {renderQuestionnaire()}
        </Container>
      </CommonLayout>
      <CommonMobileLayout width="100%">
        <Container>
          {renderQuestionnaire()}
        </Container>
      </CommonMobileLayout>
    </>
  )
}

export default Questionnaires